export const GET_DELAY_MARKED_DATA = "/api/v1/mark_delay_schedule";
export const GET_DELAY_MARKED_CALENDAR_DATA = "/api/v1/show_delay_dates";
